import React, { useEffect, useState, useContext } from "react";
import { useStyles } from "./style";
import AverageBox from "../../../components/avg-box";
import { getAggregate } from "./handler";
import withMiddleware from "../../../middleware";
import { Grid, Typography, Divider, useTheme } from "@material-ui/core";
import Chart from "../../../components/chart";
// import Trends from "../../../components/trends";
import { useUtils } from "../../../utils";
// import AvgCustom from "../avg-custom";
import { UserContext } from "../../../context";
import DashboardLoader from "../../../components/loader/dashboard";
import GraphLoader from "../../../components/loader/graph";
import BoxLoader from "../../../components/loader/box";
import NoReadings from "../../../components/static/no-readings";
import { groupSwitch } from "../groups/handler";
import { useHistory } from "react-router-dom";
import SwitchGroupLoading from "../groups/components/SwitchGroupLoading";
import GroupsWithHRV from "./components/GroupsWithHRV";
import { updateUser } from "../../../actions/app";
import { setCurrentOrg } from "../../../components/header/handler";
import { useDispatch } from "react-redux";

function Dashboard(props) {
  const { colors, showToast } = useUtils();
  const classes = useStyles(colors);
  const dispatch = useDispatch();
  const user = useContext(UserContext);
  const [averages, setAverages] = useState([]);
  // const [positiveTrends, setPositiveTrends] = useState([]);
  // const [negetiveTrends, setNegetiveTrends] = useState([]);
  const [groupSwitchLoading, setGroupSwitchLoading] = useState(false);
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const theme = useTheme();
  const divider = {
    width: 32,
    height: 4,
    background: theme.palette.primary.main,
    borderRadius: 10,
    marginBottom: 24,
  };

  useEffect(() => {
    init();
  }, [user]);

  async function init() {
    try {
      setLoading(true);
      const aggregates = await getAggregate(props.service, user.current_org_id);
      setAverages(aggregates.avg);
      setLoading(false);
    } catch (err) {
      showToast("error", err.message);
      setLoading(false);
    }
  }

  const handleSwitch = async (group_id) => {
    try {
      const org_id = user?.current_org_id;
      const user_type = "group";
      await setCurrentOrg(props.service, { currentOrgId: String(org_id), currentGroupId: String(group_id), currentUserType: user_type });
      history.push(`/${user_type}`);
      setTimeout(() => {
        dispatch(updateUser({ ...user, current_org_id: org_id, current_group_id: group_id, user_type }));
      }, 1000);
    } catch (error) {
      showToast("error", error?.message);
    }
  };

  async function navigateToProfile(user) {
    try {
      setGroupSwitchLoading(true);
      await handleSwitch(user.id);
      setGroupSwitchLoading(false);
    } catch (error) {
      setGroupSwitchLoading(false);
    }
  }

  return (
    <div className={classes.root}>
      <Grid container justify="center" spacing={4}>
        <Grid item xs={6} style={{ height: 368, paddingBottom: 0, overflowY: "auto" }}>
          {loading ? (
            <DashboardLoader />
          ) : averages.length > 0 ? (
            <Grid container justify="center" alignItems="center" className={classes.fullHeight}>
              {averages.map((avg, index) => (
                <div key={index}>
                  <AverageBox value={avg.rmssd} data={avg} />
                </div>
              ))}
              {/* <AvgCustom /> */}
            </Grid>
          ) : (
            <NoReadings />
          )}
        </Grid>
        <Grid item xs={6}>
          {loading ? <GraphLoader /> : <Chart data={averages} />}
        </Grid>
      </Grid>
      <Grid container justify="center" spacing={4} className={classes.trendContainer}>
        <Grid item xs={12}>
          <Typography className={classes.typoHead}>Groups with their HRV Trend</Typography>
          <Divider style={divider} />
          <GroupsWithHRV {...{ ...props, onRowClick: navigateToProfile }} />
        </Grid>
      </Grid>
      {/* <Grid
        container
        justify="center"
        spacing={4}
        className={classes.trendContainer}
      >
        <Grid item xs={6}>
          <Typography className={classes.typoHead}>
            Groups with positive HRV Trend
          </Typography>
          <Divider style={divider} />
          {loading ? (
            <BoxLoader height={100} />
          ) : positiveTrends.length > 0 ? (
            positiveTrends.map((trend, index) => (
              <Trends
                key={index}
                data={trend}
                onClick={() => navigateToProfile(trend)}
              />
            ))
          ) : (
            <Grid
              container
              alignContent="center"
              alignItems="center"
              justify="center"
              className={classes.emptyContainer}
            >
              <Typography className={classes.typoMessage}>
                No Groups with positive HRV Trends
              </Typography>
            </Grid>
          )}
        </Grid>
        <Grid item xs={6}>
          <Typography className={classes.typoHead}>
            Groups with negative HRV Trend
          </Typography>
          <Divider style={divider} />
          {loading ? (
            <BoxLoader height={100} />
          ) : negetiveTrends.length > 0 ? (
            negetiveTrends.map((trend, index) => (
              <Trends
                key={index}
                data={trend}
                onClick={() => navigateToProfile(trend)}
              />
            ))
          ) : (
            <Grid
              container
              alignContent="center"
              alignItems="center"
              justify="center"
              className={classes.emptyContainer}
            >
              <Typography className={classes.typoMessage}>
                No Groups with negative HRV Trends
              </Typography>
            </Grid>
          )}
        </Grid>
      </Grid> */}
      {groupSwitchLoading && <SwitchGroupLoading />}
    </div>
  );
}

export default withMiddleware(Dashboard);
